<template>
  <div class="product-family-compatibility-requirements-count">
    <span v-if="hasNoRequirements">
      <text-placeholder />
    </span>
    <span v-else-if="hasSingleRequirement">{{$t('counts.single')}}</span>
    <span v-else>{{$t('counts.multiple', { count: requirementsCount })}}</span>
  </div>
</template>

<script>
import { chain } from 'lodash';
import TextPlaceholder from '@/components/TextPlaceholder';

export default {
  name: 'product-family-compatibility-requirements-count',
  components: {
    TextPlaceholder,
  },
  props: {
    compatibility: {
      type: Object,
      required: true,
    },
  },
  computed: {
    requirementsCount() {
      return chain(this.compatibility.requirementAlternatives)
        .flatMap(alt => alt.requiredFamilies)
        .map(family => family.id)
        .value()
        .length;
    },
    hasNoRequirements() {
      return this.requirementsCount === 0;
    },
    hasSingleRequirement() {
      return this.requirementsCount === 1;
    },
  },
  i18n: {
    messages: {
      de: {
        counts: {
          single: '1 Abhängigkeit',
          multiple: '{count} Abhängigkeiten',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductFamilyCompatibilityRequirementsCount.vue?806b515e